export const app = {
  title: 'Konfigurator 3D',
}
